import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { WorkOsWidgets, UserSecurity } from '@workos-inc/widgets';

import { useAuth } from '../../workos-auth';
import { updateCurrentUserAvatar } from '../../features/user/user.slice';
import { formatPicture } from '../../core/services/image.service';
import { DescriptionHeader } from '../../features/user/components/description-header';
import { catchError } from '../../core/catch-error';
import { uiStore } from '../../core/stores/ui-store';
import { UserProfile } from './components/user-profile';

export const ProfilePage: React.FC = observer(() => {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    return ()=> {
      uiStore.pageTitle = {
        label: "",
      };
    }
  });

  return (
      <WorkOsWidgets
        style={{ minHeight: '0rem' }}
        theme={{
          appearance: 'dark',
          hasBackground: false,
          accentColor: 'var(--accentColor)',
          radius: 'medium',
          fontFamily: 'Inter',
          grayColor: 'blue',
        }}
      >
        <DescriptionHeader title="Profile" description="Manage your profile" />

        <UserProfile />

        <DescriptionHeader
          title="Password and authentication"
          description="Use email and password to log in to PRODUCER."
        />
        <UserSecurity authToken={getAccessToken} />
      </WorkOsWidgets>
  );
});
